import React from 'react'
import { propType } from 'graphql-anywhere'
import classnames from 'classnames'
import { sanitizeDom } from '../../utils'
import styles from './markdown.css'

import MARKDOWN_FRAGMENT from '../../../graphql/fragments/markdown.gql'
import { useScreenTheme } from '../../hooks/use-screen-theme'

function Markdown({ markdown }) {
  const { isWhiteTheme, isMarketing } = useScreenTheme()

  return (
    <div
      className={classnames(
        styles.wrapper,
        { [styles.whiteTheme]: isWhiteTheme || isMarketing }
      )}
    >
      <div
        className={styles.markdownWrapper}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: sanitizeDom(markdown.copy) }}
      />
    </div>
  )
}

Markdown.propTypes = {
  markdown: propType(MARKDOWN_FRAGMENT).isRequired
}

export default Markdown
